import { API } from "../../utils/_HttpUtils";
import { blog_routes as routes } from "../../constants/api-routes";

const postsList = async (search, tag, fa_tag, page, size = 10) => {
    const response = await new API().send("GET", routes.postsList, null, null, {
        page,
        size,
        ...(search && { search }),
        ...(tag && { tag }),
        ...(fa_tag && { fa_tag }),
    });
    return response.data;
};

export { postsList };
